<template>
  <div class="navigation__wrapper">
    <div
      class="navigation__mobile-icon"
      @click="toggleMenu"
    >
      <div :class="!isMenuOpen ? 'navigation__icon--open' : 'navigation__icon--close'" />
    </div>
    <div
      :class="isMenuOpen ? 'navigation__container--active' : ''"
      class="navigation__container"
    >
      <a
        class="navigation__item"
        @click="scrollTo('#product-1')"
      >
        Energy
      </a>
      <a
        class="navigation__item"
        @click="scrollTo('#product-3')"
      >
        hydration
      </a>
      <a
        href="https://www.sportpursuit.com/performance?bid=1938"
        class="navigation__item"
      >
        shop
        <span class="navigation__coming-soon"> coming soon </span>
      </a>
    </div>
  </div>
</template>
<script>
import ScrollMixin from '@/components/mixins/ScrollMixin';

export default {
  name: 'NavigationComponent',
  mixins: [ScrollMixin],
  data() {
    return {
      isMenuOpen: false,
      body: '',
    };
  },

  watch: {
    isMenuOpen() {
      if (this.isMenuOpen) {
        this.body.classList.add('menu-is-open');
      } else if (!this.isMenuOpen && this.body.classList.contains('menu-is-open')) {
        this.body.classList.remove('menu-is-open');
      }
    },
  },

  mounted() {
    this.body = document.querySelector('body');
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>
<style
  lang="scss"
  scoped
>
  .navigation {
    &__wrapper {
      display: flex;
    }

    &__container {
      width: 310px;
      display: flex;
      position: relative;
      z-index: 1;

      @include respond-to(tablet-small) {
        display: none;
      }

      &--active {
        @include respond-to(tablet-small) {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: fixed;
          height: 100%;
          opacity: 1;
          width: 100%;
          top: 49px;
          left: 0;
          background: $theme-color-accent;
          padding-top: 50px;
        }
      }
    }

    &__item {
      color: $theme-color-light;
      text-decoration: none;
      margin-right: 40px;
      font-family: Oswald;
      font-size: 0.875em;
      text-transform: uppercase;
      letter-spacing: 1.4px;
      font-weight: bold;
      cursor: pointer;

      &:last-of-type {
        margin-right: 0;
      }

      @include respond-to(tablet-small) {
        margin-right: 0;
        margin-bottom: 26px;

        &:first-of-type {
          margin-bottom: 46px;
        }

        &:last-of-type {
          margin-bottom: 0;
          display: flex;
          flex-direction: column-reverse;
          align-items: center;
        }
      }
    }

    &__coming-soon {
      font-size: 0.34em;
      letter-spacing: 0.6px;
      font-weight: bold;
      font-family: Helvetica;
      border: 1px solid $theme-color-light;
      padding: 4px 8px;
      margin-top: -21px;
      margin-left: 39px;
      display: block;

      @include respond-to(tablet-small) {
        margin: 0;
      }
    }

    &__mobile-icon {
      display: none;

      @include respond-to(tablet-small) {
        display: block;
        width: 25px;
        height: 20px;
        position: relative;
      }
    }

    &__icon {
      &--open {
        width: 100%;
        height: 4px;
        border-radius: 0.9px;
        background: $theme-color-light;
        margin-top: 8px;

        &:before, &:after {
          position: absolute;
          content: '';
          width: 100%;
          height: 4px;
          border-radius: 0.9px;
          background: $theme-color-light;
          left: 0;
          top: 0;
        }

        &:after {
          bottom: 0;
          top: auto;
        }
      }

      &--close {
        width: 25px;
        height: 25px;

        &:before, &:after {
          position: absolute;
          content: '';
          width: 2px;
          height: 25px;
          border-radius: 0.9px;
          background: $theme-color-light;
          transform: rotate(-45deg);
          top: -3px;
          left: 8px;
        }

        &:after {
          left: auto;
          right: 15px;
          transform: rotate(45deg);
        }
      }
    }
  }
</style>
